import React from 'react';

const FlagAt = props => (
  <svg viewBox="0 0 900 600" {...props}>
    <path fill="#ed2939" d="M0 0h900v600H0z" />
    <path fill="#fff" d="M0 200h900v200H0z" />
  </svg>
);

export default FlagAt;
